// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fuZkwRtvzrpCaGIkcUup{display:flex;justify-content:space-between;align-items:center;height:68px}.eiXGz8HwnC0__vQraywi{display:flex;align-items:center}.eiXGz8HwnC0__vQraywi.BVbEi23EjzAA027g9JD2{display:none}.jn_O0XLbok57IeG95B7g{display:flex}.jn_O0XLbok57IeG95B7g a{text-decoration:none}.jn_O0XLbok57IeG95B7g.D2CFEcTdYSli6NeBkklw{justify-content:flex-end}.jn_O0XLbok57IeG95B7g.FLcsfv4YCAtDh6NTlHwi{justify-content:flex-start}.LSZsOPu3yO93AmBv7340{width:.5rem;height:.5rem;margin:0 .25rem;border-radius:50%;background:#8496b9;cursor:pointer}.LSZsOPu3yO93AmBv7340:hover{background:#6e32f0}.LSZsOPu3yO93AmBv7340.p6dVTelE2G656eG6nRMw{background:#6e32f0}.jSSNdkzqebDALR8Jq2E4 i{color:#8496b9 !important}.jSSNdkzqebDALR8Jq2E4:hover{border-color:#da003e !important}.jSSNdkzqebDALR8Jq2E4:hover i{color:#da003e !important}.jSSNdkzqebDALR8Jq2E4:active{border-color:#da003e !important;background-color:#da003e !important}.jSSNdkzqebDALR8Jq2E4:active i{color:#fff !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"navbar": `fuZkwRtvzrpCaGIkcUup`,
	"breadcrumbs": `eiXGz8HwnC0__vQraywi`,
	"hidden": `BVbEi23EjzAA027g9JD2`,
	"buttonContainer": `jn_O0XLbok57IeG95B7g`,
	"right": `D2CFEcTdYSli6NeBkklw`,
	"left": `FLcsfv4YCAtDh6NTlHwi`,
	"dot": `LSZsOPu3yO93AmBv7340`,
	"active": `p6dVTelE2G656eG6nRMw`,
	"restore": `jSSNdkzqebDALR8Jq2E4`
};
export default ___CSS_LOADER_EXPORT___;
